module.exports = __webpack_public_path__ + "img/thumb-mms.7efb9554.jpg";